import React, { useContext } from "react";
import { COLLEGE } from "../../../../utils";
import PsContext from "../../../../context";

const Style1 = () => {
  const context = useContext(PsContext);
  const cards = [
    {
      title: "Student Image",
      specs: "50 kb - 300 kb",
      icon: "camera",
      desc: "Photo with white background only allowed No selfie allowed",
    },
    {
      title: "Upload Your Signature",
      specs: "30 kb - 100 kb",
      icon: "file-signature",
      desc: "signature should be in .png or .jpg format only.",
    },
    {
      title: "Parent/Guardian Image",
      specs: "10 kb - 200 kb",
      icon: "camera",
      desc: "Photo with white background only allowed No selfie allowed.",
    },
    {
      title: "Other Certificates",
      specs: "80 kb - 300 kb",
      icon: "file",
      desc: "Certificates in .pdf or .jpg or .png format only.",
    },
  ];

  return (
    <div className="text-center text-md-start slide-up-animation pb-2">
      <div className="d-inline-flex align-items-center bg-white bg-opacity-10 border border-white border-opacity-25 rounded-pill px-3 py-1 mb-3 backdrop-blur shadow-sm sliding-pill">
        <span className="badge bg-warning text-dark rounded-pill me-2 only-new-sliding">
          NEW
        </span>
        <span className="text-white fs-13 fw-600 letter-spacing-1 admission-text-fixed">
          Admissions Platform
        </span>
      </div>
      <h3 className="text-white fw-900 display-4 mb-2 text-shadow-sm">
        Welcome to {COLLEGE || "Our"} Admissions
      </h3>
      <p className="text-light fs-16 fw-500 opacity-75 max-w-600 mx-auto mx-md-0">
        Begin your academic journey today. Experience our seamless and fully
        digital enrollment process.
      </p>

      <div className="marquee-container mt-4 slide-up-animation-delay-1 px-0 mb-5">
        <div className="marquee-inner">
          {[...cards, ...cards, ...cards].map((item, index) => {
            const variantNumber = (index % 6) + 1;
            return (
              <div
                key={index}
                className={`marquee-card mx-3 step-variant-${variantNumber}`}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="program-icon-box px-3 py-2 rounded-1 me-3"
                    style={{ width: "35px", height: "35px" }}
                  >
                    <i className={`fa fa-solid fa-${item.icon} fs-16`}></i>
                  </div>
                  <h5 className="fw-700 m-0 fs-16 text-dark text-nowrap">
                    {item.title}
                  </h5>
                </div>
                <div className="bg-light p-1 rounded mb-3">
                  <small className="text-muted text-uppercase fw-600 fs-10 letter-spacing-1 d-block mb-1">
                    Specifications
                  </small>
                  <p className="text-dark fw-700 fs-14 m-0 text-nowrap">
                    {item.specs}
                  </p>
                </div>
                <p className="text-muted fs-12 mb-0 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Style1;
